import styled from 'styled-components';

export const ErrorMessageBox = styled.div`
  margin: 4px 0 0;
  color: #E52E59;
  font-size: 14px;

  &:empty {
    display: none;
  };
`;
